import register from '@kpsys/angularjs-register';
import changelogRoutes from './changelog.routes';

export default register('portaro.features.changelog')
    .config(changelogRoutes)
    .name();
